import React from "react";
import { Switch, Route } from "react-router-dom";
import HomeDashboard from "./Index";

export default () => (
  <Switch>
    <Route path="/" component={HomeDashboard} />
  </Switch>
);
